import { decode } from "html-entities";

export class HtmlLogic {
   
    public decodeHtml(html: string): string {
        return decode(html, {level: "html5"});
    }
}

export const HtmlLogicSingleton = new HtmlLogic();